module.exports = __webpack_public_path__ + "img/cs-tab-icon2.f4ac21b8.png";